module.exports = __webpack_public_path__ + "static/3-9d306ff51f85dde8f33afd8333d9c976.jpg";